import gsap from 'gsap';


let bgVideo = promokit.video({
  el: '.section-3__bg-video',
  url: 'https://vod.plaync.com/lineage/remaster/Lineage_remastered_lancer_new_class.mp4',
  loop: true,
  preload: true
});

let video1 = promokit.youtube({
  el: '#player',
  youtubeid: '02yxofHqQjk',
  controls: true,
  autoplay: false,
  mute: false
});


let urlPath = promokit.store('staticPath');


var viewer1 = promokit.viewer({
  images: [
    {
      src: `${urlPath}/promo/lineage/history/2020/200722_lancer/img/pc/slide/item-1.jpg`,
      title: '아인하사드의 고통'
    },
    {
      src: `${urlPath}/promo/lineage/history/2020/200722_lancer/img/pc/slide/item-2.jpg`,
      title: '아인하사드의 결심'
    },
    {
      src: `${urlPath}/promo/lineage/history/2020/200722_lancer/img/pc/slide/item-3.jpg`,
      title: '그랑카인의 공포'
    },
    {
      src: `${urlPath}/promo/lineage/history/2020/200722_lancer/img/pc/slide/item-4.jpg`,
      title: '테이아의 혼돈'
    },
    {
      src: `${urlPath}/promo/lineage/history/2020/200722_lancer/img/pc/slide/item-5.jpg`,
      title: '에바의 서약'
    },
    {
      src: `${urlPath}/promo/lineage/history/2020/200722_lancer/img/pc/slide/item-6.jpg`,
      title: '단테스의 시련'
    },
    {
      src: `${urlPath}/promo/lineage/history/2020/200722_lancer/img/pc/slide/item-7.jpg`,
      title: '아우라키아의 초월'
    },
    {
      src: `${urlPath}/promo/lineage/history/2020/200722_lancer/img/pc/slide/item-8.jpg`,
      title: '마프르의 고뇌'
    },
  ],
  buttons: '.viewer-open'
});


let subPageIndex = 1;

const subPageAnimation = {
  'section-3-1': gsap.timeline({paused: true})
      .addLabel('start')
      .from('.section-3-1__title', {opacity: 0, y: '+=20', duration: 1}, 'start+=.6')
      .from('.section-3-1__con1', {opacity: 0, y: '+=60', duration: .6}, 'start+=.8')
      .from('.section-3-1__con2', {opacity: 0, y: '+=60', duration: .6}, 'start+=1'),

  'section-3-2': gsap.timeline({paused: true})
      .addLabel('start')
      .from('.section-3-2__title', {opacity: 0, y: '+=20', duration: 1}, 'start+=.6')
      .from('.section-3-2__con', {opacity: 0, y: '+=40', duration: .6}, 'start+=.8'),
  'section-3-3': gsap.timeline({paused: true})
      .addLabel('start')
      .from('.section-3-3__title', {opacity: 0, y: '+=20', duration: 1}, 'start+=.6')
      .staggerFrom(
        '.section-3-3__con li',
       0.6, {y:50, opacity:0,ease: "power2.out",}, 0.1, 'start+=1.1')

};

const mountAnimation = gsap.timeline({paused: true})
    .addLabel('start')
    .from('.section-3__menu', {opacity: 0, duration: 1}, 'start+=.6');


const SubPageRouter = (toPageIndex, delay = 0) => {
  let prevPageIndex = subPageIndex;

  $('.section-3__menu-item--active').removeClass('section-3__menu-item--active');
  $(`.section-3__menu-item--${toPageIndex}`).addClass('section-3__menu-item--active');
  $('.section-3__menu')
      .removeClass(`section-3__menu--active-1 
                    section-3__menu--active-2
                    section-3__menu--active-3
                    `)
      .addClass(`section-3__menu--active-${toPageIndex}`);

  $('.section-3__con--active').removeClass('section-3__con--active');
  $(`.section-3-${toPageIndex}`).addClass('section-3__con--active');

  if (prevPageIndex !== toPageIndex) {
    subPageAnimation[`section-3-${toPageIndex}`].restart();
  }
  else {
    setTimeout(() => {
      subPageAnimation[`section-3-${prevPageIndex}`].restart();
    }, 600);
  }

  subPageIndex = toPageIndex;
};

$(document).on('click', '.section-3__menu-item a', function(e){
  e.preventDefault();
  let index = $(this)[0].hash.replace(/(#s|s)ection-\d-/, '');

  if (subPageIndex == index) return;
  SubPageRouter(index);

  if(index != 1){
    if(video1){
      video1.stop();
      video1.seek(0);
    }
  }
});

export default {
  id: '#section-3',

  name: '신규 클래스',

  backgroundVideo: bgVideo,

  videoPlayer: video1,


  enterStart() {
    mountAnimation.play();
    SubPageRouter(subPageIndex, 300);
  },

  leaveEnd() {
    mountAnimation.seek(0).pause();
    subPageAnimation[`section-3-${subPageIndex}`].seek(0).pause();
  }
};



// WEBPACK FOOTER //
// ./src/js/pc/section-3.js